exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3QIRli6o1gRn_J0p5PTJa2{font-size:16px}html[dir=ltr] ._3QIRli6o1gRn_J0p5PTJa2{padding-left:0}html[dir=rtl] ._3QIRli6o1gRn_J0p5PTJa2{padding-right:0}", ""]);

// exports
exports.locals = {
	"star": "_3QIRli6o1gRn_J0p5PTJa2"
};